import { Link } from "react-router-dom"

export default function Logo() {
  return (
    <>
      <Link to="/">
        <h2 className="text-white text-4xl">Logo</h2>
      </Link>
    </>
  )
}
